import { render } from "./DiscountsIndex.vue?vue&type=template&id=6c10cf90"
import script from "./DiscountsIndex.vue?vue&type=script&lang=js"
export * from "./DiscountsIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__